import Component from '@glimmer/component'
import { htmlSafe } from '@ember/template'

interface Data {
  color: string
  label: string
  data: string
}

interface Args {
  data: Data[]
  labelsBelow: boolean
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

export class ChartLegend extends Component<Signature> {
  get categories() {
    return this.args.data.map((category) => {
      const style = htmlSafe(`background-color: ${category.color} !important;`) // needs to be important so shows up on print
      return { ...category, style }
    })
  }

  <template>
    <div data-test-chart-legend class="flex flex-nowrap items-center justify-center" ...attributes>
      {{#each this.categories as |category index|}}
        <div data-test-legend-item={{index}} class="shrink grow basis-full text-center">
          <span data-test-legend-circle class="inline-block h-3 w-3 rounded-full" style={{category.style}}></span>
          <span data-test-legend-label class="{{if @labelsBelow 'block text-xs'}} font-bold">
            {{category.label}}
          </span>
          <span data-test-legend-data class="{{if @labelsBelow 'block text-xl'}} font-bold">
            {{category.data}}
          </span>
        </div>
      {{/each}}
    </div>
  </template>
}

export default ChartLegend
